var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.$t('Integrations')))]),_c('IntegrationsTable',{attrs:{"url":_vm.integrationsUrl}}),_c('AvailableIntegrations')],1)}
var staticRenderFns = []

export { render, staticRenderFns }